'use client';
import { AuthAffordance, AuthAffordanceVariant } from '@vs-shop/commerce-ui/authAffordance';
import { ChevronLeft } from 'lucide-react';
import { useIntl } from 'react-intl';

import ResetPasswordForm from './ResetPasswordForm';

import { authModalAtom, AuthModalMode } from '@vs-shop/engine/atom/ui/authModal';
import { useAtomSet } from '@effect/atom-react';

export default function ResetPasswordModalContent() {
  const intl = useIntl();
  const setAuthModal = useAtomSet(authModalAtom);

  const onClick = () => {
    setAuthModal((prev) => ({ ...prev, mode: AuthModalMode.login }));
  };

  return (
    <div className="space-y-4 p-6">
      <AuthAffordance
        variant={AuthAffordanceVariant.UNSTYLED}
        className="flex cursor-pointer items-center gap-4"
        onClick={onClick}
      >
        <ChevronLeft />
        <span className="text-lg">
          {intl.formatMessage({
            id: 'component.authModal.resetPassword.heading',
            defaultMessage: 'Zpět na přihlášení',
          })}
        </span>
      </AuthAffordance>

      <ResetPasswordForm />
    </div>
  );
}
